<div class="flex flex-col container box-border items-center gap-6 my-14 p-14">
    <div>
        <img width="360" src="/assets/images/error-403.svg" />
    </div>
    <div class="flex justify-center" data-testid="error-page-title">
        <strong class="ca-headline-1 mb-0">{{ 'COMMON.ERRORS.403.TITLE' | translate }}</strong>
    </div>
    <div class="flex flex-col items-center gap-6">
        <div>{{ 'COMMON.ERRORS.403.CONTENT' | translate }}</div>
        <div>{{ 'COMMON.ERRORS.403.SALES_CONTACT' | translate }}</div>
    </div>
    <hr />
    <div class="flex flex-col items-center gap-6 mt-6">
        <div>{{ 'COMMON.ERRORS.403.CONTACT' | translate }}</div>

        <div class="flex justify-center">
            <a href="https://live.viessmann-climatesolutions.com/de/kontakt.html" data-testid="error-page-link">
                <button mat-stroked-button class="ca-button mt-auto">
                    <span class="button-title">{{ 'COMMON.ERRORS.403.FORM_BUTTON' | translate }}</span>
                    <ca-icon icon="arrow-outward" class="ca-icon-s"></ca-icon>
                </button>
            </a>
        </div>
    </div>
</div>
